import React, {useContext} from 'react';
import clsx from 'clsx';
import Navigation from '../../Navigation/VerticleNav';
import Box from '@material-ui/core/Box';
import useStyles from './AppSidebar.style';
import Scrollbar from '../../Scrollbar';
import AppContextPropsType from '../../../../types/AppContextPropsType';
import AppContext from '../../../utility/AppContext';

// import {
//   useLayoutActionsContext,
// } from '../LayoutContextProvider';

interface AppSidebarProps {
  position?: 'left' | 'bottom' | 'right' | 'top';
  variant?: string;
}

const AppSidebar: React.FC<AppSidebarProps> = ({
  position = 'left',
  variant = '',
}) => {
  //const {navCollapsed} = useLayoutContext();
  //const dispatch = useLayoutActionsContext()!;

  const {themeMode} = useContext<AppContextPropsType>(AppContext);

  // const handleToggleDrawer = () => {
  //   dispatch(toggleNavCollapsed());
  // };

  const classes = useStyles({themeMode});
  let sidebarClasses = classes.sidebarStandard;

  return (
    <>
      <Box height='100%' className={clsx(classes.miniSidebar, 'app-sidebar')}>
        <Box className={clsx(classes.sidebarBg, sidebarClasses)}>
          <Scrollbar scrollToTop={false} className={classes.scrollAppSidebar}>
            <Navigation />
          </Scrollbar>
        </Box>
      </Box>
    </>
  );
};

export default AppSidebar;
